import authSlice from './authSlice/authSlice';
import UserSlice from './userSlice/userSlice';
import MerchantSlice from './merchantSlice/merchantSlice';
import MerchantInfoSlice from './merchantInfoSlice/merchantInfoSlice';
import StationSlice from './stationSlice/stationSlice';
import PowerBankSlice from './powerBankSlice/powerBankSlice';
import OrderSlice from './orderSlice/orderSlice';
import AdminUserSlice from './adminUserSlice/adminUserSlice';
import DashboardSlice from './dashboardSlice/dashboardSlice';
import SystemErrorSlice from './systemErrorSlice/systemErrorSlice';
import RegionEditSlice from './regionEditSlice/RegionEditslice';
import ProfitabilityAnalysisSlice from './profitabilityAnalysisSlice/ProfitabilityAnalysisSlice';
import SettlementsSlice from './settlementsSlice/SettlementsSlice';
import CouponSlice from './couponSlice/couponSlice';
import EmergencyCenterSlice from './emergencyCenterSlice/emergencyCenterSlice';
import EInvoiceSlice from './eInvoiceSlice/eInvoiceSlice';
import PayoutLogSlice from './payoutLogSlice/payoutLogSlice';
import PayoutSettingSlice from './payoutSettingSlice/payoutSettingSlice';
import PriceStrategySlice from './priceStrategySlice/priceStrategySlice';

export const rootReducer = {
  authSlice,
  UserSlice,
  MerchantSlice,
  MerchantInfoSlice,
  StationSlice,
  PowerBankSlice,
  OrderSlice,
  AdminUserSlice,
  DashboardSlice,
  SystemErrorSlice,
  RegionEditSlice,
  ProfitabilityAnalysisSlice,
  SettlementsSlice,
  CouponSlice,
  EmergencyCenterSlice,
  EInvoiceSlice,
  PriceStrategySlice,
  PayoutSettingSlice,
  PayoutLogSlice,
};
